var JoyObjectType;
(function (JoyObjectType) {
    JoyObjectType["activity"] = "activity";
    JoyObjectType["album"] = "album";
    JoyObjectType["comment"] = "comment";
    JoyObjectType["group"] = "group";
    JoyObjectType["medium"] = "medium";
    JoyObjectType["user"] = "user";
})(JoyObjectType || (JoyObjectType = {}));
export default JoyObjectType;
//# sourceMappingURL=JoyObjectType.js.map